import Vue from 'vue'
import Router from 'vue-router'

const home = r => require.ensure([],()=> r (require('../page/home/home')),'home')
const lpDetail = r => require.ensure([],()=> r (require('../page/Lp/lpDetail')),'lpDetail')
const lplist = r => require.ensure([],()=> r (require('../page/Lp/lplist')),'lplist')

// 资讯模块
const news = r => require.ensure([],()=> r (require('../page/news/news')),'news')
const newsDetail = r => require.ensure([],()=> r (require('../page/news/newsDetail')),'newsDetail')


// 用户模块
const myinfo = r => require.ensure([],()=> r (require('../page/myinfo/myinfo')),'myinfo')
const login = r => require.ensure([],()=> r (require('../page/login/login')),'login')
const register = r => require.ensure([],()=> r (require('../page/myinfo/register')),'register')
const modifypd = r => require.ensure([],()=> r (require('../page/myinfo/modifypd')),'modifypd')
const myreport = r => require.ensure([],()=> r (require('../page/myinfo/myreport')),'myreport')
const report = r => require.ensure([],()=> r (require('../page/myinfo/report')),'report')
const info = r => require.ensure([],()=> r (require('../page/myinfo/info')),'info')
const myconession = r => require.ensure([],()=> r (require('../page/myinfo/myconession')),'myconession')
const reportdetail = r => require.ensure([],()=> r (require('../page/myinfo/reportdetail')),'reportdetail')
const mymessage = r => require.ensure([],()=> r (require('../page/myinfo/mymessage')),'mymessage')
const message = r => require.ensure([],()=> r (require('../page/myinfo/message')),'message')
const settlement = r => require.ensure([],()=> r (require('../page/myinfo/settlement')),'settlement')
const agreement = r => require.ensure([],()=> r (require('../page/myinfo/agreement')),'agreement')
const binding = r => require.ensure([],()=> r (require('../page/myinfo/binding')),'binding')
const search = r => require.ensure([],()=> r (require('../page/myinfo/search')),'search')

const myInvite = r => require.ensure([],()=> r (require('../page/myinfo/myInvite')),'myInvite')
const myqrcode = r => require.ensure([],()=> r (require('../page/myinfo/myqrcode')),'myqrcode')



Vue.use(Router)

export default new Router({
  //mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'Hello',
    //   component: Hello
    // },
    { path: '/', name: 'Home', component: home },

    /*****  首页模块  *****/
    // 首页
    { path: '/home', name: 'Home', component: home },

    { path: '/', name: 'Myinfo', component: myinfo },

    // 楼盘详情
    { path: '/lpDetail', name: 'LpDetail', component: lpDetail },

    // 楼盘列表
    { path: '/lplist', name: 'lplist', component: lplist },

    /*****  资讯模块  *****/
    // 楼盘资讯
    { path: '/news', name: 'News', component: news },

    // 资讯详情
    { path: '/newsDetail', name: 'NewsDetail', component: newsDetail },


    /*****  用户模块  *****/
    // 个人中心
    { path: '/myinfo', name: 'Myinfo', component: myinfo },

    // 用户登录
    { path: '/login', name: 'Login', component: login },

    // 用户注册
    { path: '/register', name: 'Register', component: register },

    // 用户修改密码
    { path: '/modifypd', name: 'Modifypd', component: modifypd },

    // 我的报备
    { path: '/myreport', name: 'Myreport', component: myreport },

    // 报备客户
    { path: '/report', name: 'Report', component: report },

    // 用户资料
    { path: '/info', name: 'Info', component: info },

    // 我的佣金
    { path: '/myconession', name: 'Myconession', component: myconession },

    // 客户详情
    { path: '/reportdetail', name: 'Reportdetail', component: reportdetail },

    // 我的消息
    { path: '/mymessage', name: 'Mymessage', component: mymessage },

    // 消息
    { path: '/message', name: 'Message', component: message },

    // 结算信息
    { path:'/settlement', name: 'Settlement', component: settlement },

    // 注册协议
    { path:'/agreement', name: 'Agreement', component: agreement },

    // 绑定账号
    { path:'/binding', name: 'Binding', component: binding },

    // 搜索
    { path:'/search', name: 'Search', component: search },

    // 团队
    { path:'/myInvite', name: 'MyInvite', component: myInvite },

    // 我的二维码
    { path:'/myqrcode', name: 'Myqrcode', component: myqrcode },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js